export const soundList = [
  ["None", undefined],
  ["Default", "/telegraph.mp3"],
  ["Siren", "/alert-102266.mp3"],
  ["Deep Ping", "/deepPing.mp3"],
] as const;

export const playSoundByURL = (url: string): Promise<void> =>
  new Promise((resolve, reject) => {
    try {
      const soundSource = url;

      const sound = new Audio(soundSource);

      sound.volume = 1;

      sound.onended = (): void => resolve();

      sound.play();
    } catch (error) {
      reject(error);
    }
  });

export const playDefaultNotification = (): Promise<void> => playSoundByURL(soundList[1][1]);

export const playSoundFromSoundList = (index: number): void => {
  const [, url] = soundList[index];

  if (url) {
    playSoundByURL(url);
  }
};
